import { render, staticRenderFns } from "./HappySmileySVG.vue?vue&type=template&id=27838f7c&scoped=true&"
import script from "./HappySmileySVG.vue?vue&type=script&lang=js&"
export * from "./HappySmileySVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27838f7c",
  null
  
)

export default component.exports